(function() {
    'use strict';

    angular.module('app.procesosMasivos', []);
})();
